import { useRef, useCallback, useEffect } from 'react'

export const useShadowEffects = (
  scrollRef: React.RefObject<HTMLDivElement>
) => {
  const topShadowRef = useRef<HTMLDivElement>(null)
  const bottomShadowRef = useRef<HTMLDivElement>(null)
  const leftShadowRef = useRef<HTMLDivElement>(null)
  const rightShadowRef = useRef<HTMLDivElement>(null)

  const handleScroll = useCallback(() => {
    const container = scrollRef.current
    if (!container) return

    const {
      scrollTop,
      scrollLeft,
      scrollHeight,
      scrollWidth,
      clientHeight,
      clientWidth
    } = container

    if (topShadowRef.current) {
      topShadowRef.current.style.display = scrollTop > 5 ? 'block' : 'none'
    }
    if (bottomShadowRef.current) {
      bottomShadowRef.current.style.display =
        scrollTop < scrollHeight - clientHeight - 5 ? 'block' : 'none'
    }
    if (leftShadowRef.current) {
      leftShadowRef.current.style.display = scrollLeft > 5 ? 'block' : 'none'
    }
    if (rightShadowRef.current) {
      rightShadowRef.current.style.display =
        scrollLeft < scrollWidth - clientWidth - 5 ? 'block' : 'none'
    }
  }, [scrollRef])

  useEffect(() => {
    const container = scrollRef.current
    if (!container) return

    handleScroll()
    container.addEventListener('scroll', handleScroll, { passive: true })
    return () => container.removeEventListener('scroll', handleScroll)
  }, [handleScroll, scrollRef])

  useEffect(() => {
    const container = scrollRef.current
    if (!container) return

    handleScroll()

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(() => {
        handleScroll()
      })
      resizeObserver.observe(container)

      return () => resizeObserver.disconnect()
    }

    const handleResize = () => handleScroll()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [handleScroll, scrollRef])

  return {
    topShadowRef,
    bottomShadowRef,
    leftShadowRef,
    rightShadowRef,
    handleScroll
  }
}
